<!-- <div class="min-h-screen bg-slate-50 p-4 font-sans antialiased text-xs">
      <div class="max-w-7xl mx-auto space-y-3">

            <div class="bg-white rounded-md shadow-sm border border-slate-200 p-3">
                  <div class="flex items-center justify-between">
                        <div>
                              <h2 class="text-sm font-bold text-slate-800 uppercase tracking-tight">Meta Field
                                    Management</h2>
                              <p class="text-[10px] text-slate-500 uppercase">Dynamic UI Schema Configuration</p>
                        </div>

                        <div class="flex items-center gap-2">
                              <div class="relative">
                                    <span
                                          class="absolute inset-y-0 left-0 pl-2.5 flex items-center pointer-events-none text-slate-400">
                                          <svg class="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24"
                                                stroke="currentColor">
                                                <path d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                                                      stroke-width="2" />
                                          </svg>
                                    </span>
                                    <input type="text" [(ngModel)]="searchTerm" (input)="applyFilter()"
                                          placeholder="Search fields..."
                                          class="w-48 pl-8 pr-2 py-1.5 border border-slate-200 rounded text-xs focus:ring-1 focus:ring-blue-500 outline-none" />
                              </div>

                              <button (click)="openCreateModal()"
                                    class="bg-blue-600 hover:bg-blue-700 text-white px-3 py-1.5 rounded font-semibold transition-all shadow-sm">
                                    + New Field
                              </button>
                        </div>
                  </div>
            </div>

            <div class="bg-white rounded-md shadow-sm border border-slate-200 overflow-hidden">
                  <div class="overflow-x-auto">
                        <table class="w-full text-left border-collapse">
                              <thead>
                                    <tr
                                          class="bg-slate-50 border-b border-slate-200 text-slate-500 text-[10px] uppercase tracking-wider font-bold">
                                          <th class="px-3 py-2">Entity</th>
                                          <th class="px-3 py-2">Field ID</th>
                                          <th class="px-3 py-2">Label / Name</th>
                                          <th class="px-3 py-2">Control Type</th>
                                          <th class="px-3 py-2 text-center">Required</th>
                                          <th class="px-3 py-2">Category</th>
                                          <th class="px-3 py-2 text-right">Actions</th>
                                    </tr>
                              </thead>
                              <tbody class="divide-y divide-slate-100">
                                    <tr *ngFor="let m of list" class="hover:bg-blue-50/50 transition-colors group">
                                          <td class="px-3 py-2 font-semibold text-slate-700">{{ m.entityName }}</td>
                                          <td class="px-3 py-2 font-mono text-blue-600 font-bold">{{ m.fieldId }}</td>
                                          <td class="px-3 py-2">
                                                <div class="font-medium text-slate-800">{{ m.label }}</div>
                                                <div class="text-[10px] text-slate-400 font-mono">{{ m.name }}</div>
                                          </td>
                                          <td class="px-3 py-2">
                                                <span
                                                      class="px-1.5 py-0.5 rounded bg-blue-50 border border-blue-100 text-blue-700 text-[10px] uppercase font-bold">
                                                      {{ m.type }}
                                                </span>
                                          </td>
                                          <td class="px-3 py-2 text-center">
                                                <span *ngIf="m.isRequired" class="text-red-500 font-bold">YES</span>
                                                <span *ngIf="!m.isRequired" class="text-slate-300">NO</span>
                                          </td>
                                          <td class="px-3 py-2 italic text-slate-500">{{ m.category }}</td>
                                          <td class="px-3 py-2 text-right">
                                                <div class="flex justify-end gap-1 opacity-40 group-hover:opacity-100">
                                                      <button (click)="openEditModal(m)"
                                                            class="p-1 hover:text-blue-600 transition-colors"><svg
                                                                  class="w-4 h-4" fill="none" stroke="currentColor"
                                                                  viewBox="0 0 24 24">
                                                                  <path d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
                                                                        stroke-width="2" />
                                                            </svg></button>
                                                      <button (click)="delete(m.id)"
                                                            class="p-1 hover:text-red-600 transition-colors"><svg
                                                                  class="w-4 h-4" fill="none" stroke="currentColor"
                                                                  viewBox="0 0 24 24">
                                                                  <path d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                                                                        stroke-width="2" />
                                                            </svg></button>
                                                </div>
                                          </td>
                                    </tr>
                              </tbody>
                        </table>
                  </div>

                  <div class="flex items-center justify-between px-4 py-2.5 bg-white border-t border-slate-200">
                        <div class="flex items-center gap-3 font-bold">
                              <span>Show</span>
                              <select [value]="pageSize" (change)="changePageSize($event)"
                                    class="border-2 border-slate-200 rounded px-2 py-1 outline-none focus:border-blue-500 text-xs">
                                    <option [value]="5">5</option>
                                    <option [value]="10">10</option>
                                    <option [value]="25">25</option>
                                    <option [value]="30">30</option>
                                    <option [value]="50">50</option>
                                    <option [value]="80">80</option>
                              </select>
                              <span class="text-slate-500">per page</span>
                        </div>

                        <div class="flex items-center gap-4">
                              <span class="text-slate-600 font-medium">
                                    {{ total === 0 ? 0 : pageIndex * pageSize + 1 }}-{{ (pageIndex + 1) * pageSize >
                                    total ? total : (pageIndex + 1) * pageSize }} of {{ total }}
                              </span>

                              <div class="flex gap-1">
                                    <button (click)="goToPage(pageIndex - 1)" [disabled]="pageIndex === 0"
                                          class="w-8 h-8 flex items-center justify-center rounded border border-slate-300 bg-white hover:bg-slate-100 disabled:opacity-30 shadow-sm">
                                          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path d="M15 19l-7-7 7-7" stroke-width="2" />
                                          </svg>
                                    </button>

                                    <div
                                          class="w-8 h-8 flex items-center justify-center bg-slate-100 border border-slate-200 rounded text-slate-900 font-bold shadow-inner">
                                          {{ pageIndex + 1 }}
                                    </div>

                                    <button (click)="goToPage(pageIndex + 1)"
                                          [disabled]="(pageIndex + 1) * pageSize >= total"
                                          class="w-8 h-8 flex items-center justify-center rounded border border-slate-300 bg-white hover:bg-slate-100 disabled:opacity-30 shadow-sm">
                                          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path d="M9 5l7 7-7 7" stroke-width="2" />
                                          </svg>
                                    </button>
                              </div>
                        </div>
                  </div>
            </div>
      </div>
</div>

<div *ngIf="isModalOpen"
      class="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/40 backdrop-blur-[2px]">
      <div
            class="bg-white rounded-lg shadow-xl w-full max-w-2xl p-5 border border-slate-200 animate-in zoom-in duration-200">
            <div class="flex justify-between items-center border-b border-slate-100 pb-3 mb-4">
                  <h3 class="text-sm font-bold text-slate-800 uppercase tracking-tight">{{ isEditMode ? 'Modify' :
                        'Create' }} Meta Field</h3>
                  <button (click)="closeModal()"
                        class="text-slate-400 hover:text-slate-600 transition-colors">✕</button>
            </div>

            <div class="grid grid-cols-2 gap-4">
                  <div>
                        <label class="text-[10px] font-bold text-slate-500 uppercase mb-1 block">Field ID</label>
                        <input [(ngModel)]="form.fieldId"
                              class="w-full border border-slate-200 rounded px-2 py-1.5 text-xs focus:ring-1 focus:ring-blue-500 outline-none font-mono">
                  </div>
                  <div>
                        <label class="text-[10px] font-bold text-slate-500 uppercase mb-1 block">Display Label</label>
                        <input [(ngModel)]="form.label"
                              class="w-full border border-slate-200 rounded px-2 py-1.5 text-xs focus:ring-1 focus:ring-blue-500 outline-none">
                  </div>
                  <div>
                        <label class="text-[10px] font-bold text-slate-500 uppercase mb-1 block">Control Type</label>
                        <select [(ngModel)]="form.type"
                              class="w-full border border-slate-200 rounded px-2 py-1.5 text-xs focus:ring-1 focus:ring-blue-500 outline-none bg-white">
                              <option value="text">Text Input</option>
                              <option value="select">Select Menu</option>
                              <option value="autocomplete">Autocomplete</option>
                              <option value="datepicker">Date Picker</option>
                        </select>
                  </div>
                  <div>
                        <label class="text-[10px] font-bold text-slate-500 uppercase mb-1 block">Category</label>
                        <select [(ngModel)]="form.category"
                              class="w-full border border-slate-200 rounded px-2 py-1.5 text-xs focus:ring-1 focus:ring-blue-500 outline-none bg-white">
                              <option value="static">Static</option>
                              <option value="dynamic">Dynamic</option>
                        </select>
                  </div>
                  <div class="col-span-2">
                        <label class="text-[10px] font-bold text-slate-500 uppercase mb-1 block">Data Source
                              (JSON)</label>
                        <textarea [(ngModel)]="form.dataSource" rows="3"
                              class="w-full border border-slate-200 rounded px-2 py-1.5 text-[11px] font-mono focus:ring-1 focus:ring-blue-500 outline-none bg-slate-50"></textarea>
                  </div>
            </div>

            <div class="flex justify-end gap-2 mt-6 pt-4 border-t border-slate-100">
                  <button (click)="closeModal()"
                        class="px-4 py-1.5 border border-slate-200 text-slate-600 rounded text-xs font-semibold hover:bg-slate-50">Cancel</button>
                  <button (click)="save()"
                        class="px-4 py-1.5 bg-blue-600 text-white rounded text-xs font-bold hover:bg-blue-700 shadow-sm transition-all">
                        {{ isEditMode ? 'UPDATE RECORD' : 'SAVE FIELD' }}
                  </button>
            </div>
      </div>
</div> -->

<div class="min-h-screen bg-slate-50 p-4 font-sans antialiased text-xs text-slate-700">
      <div class="max-w-full mx-auto space-y-3">

            <div class="bg-white rounded-md shadow-sm border border-slate-200 p-3">
                  <div class="flex items-center justify-between">
                        <div>
                              <h2 class="text-sm font-bold text-slate-800 uppercase tracking-tight">Meta Field
                                    Management</h2>
                              <p class="text-[10px] text-slate-500 uppercase">Dynamic UI Schema Configuration</p>
                        </div>

                        <div class="flex items-center gap-2">
                              <div class="relative">
                                    <span
                                          class="absolute inset-y-0 left-0 pl-2.5 flex items-center pointer-events-none text-slate-400">
                                          <svg class="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24"
                                                stroke="currentColor">
                                                <path d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                                                      stroke-width="2" />
                                          </svg>
                                    </span>
                                    <input type="text" [(ngModel)]="searchTerm" (input)="applyFilter()"
                                          placeholder="Search metadata..."
                                          class="w-64 pl-8 pr-2 py-1.5 border border-slate-200 rounded text-xs focus:ring-1 focus:ring-blue-500 outline-none" />
                              </div>
                              <button (click)="openCreateModal()"
                                    class="bg-blue-600 hover:bg-blue-700 text-white px-4 py-1.5 rounded font-bold shadow-sm uppercase text-[10px]">
                                    + New Field
                              </button>
                        </div>
                  </div>
            </div>

            <div class="bg-white rounded-md shadow-sm border border-slate-200 overflow-hidden">


                  <div class="overflow-x-auto">
                        <table class="w-full text-left border-collapse min-w-[1000px]">
                              <thead>
                                    <tr
                                          class="bg-slate-50 border-b border-slate-200 text-slate-500 text-[10px] uppercase tracking-wider font-bold">
                                          <th class="px-3 py-1.5 w-32">Entity / ID</th>
                                          <th class="px-3 py-1.5 w-40">Label / Name</th>
                                          <th class="px-3 py-1.5 w-32">Type / Category</th>
                                          <th class="px-3 py-1.5 w-16 text-center">Req.</th>
                                          <th class="px-3 py-1.5 w-52">Logic & Expressions</th>
                                          <th class="px-3 py-1.5 w-52">Source / Options</th>
                                          <th class="px-3 py-1.5 w-28">Visibility / Seq</th>
                                          <th class="px-3 py-1.5 w-24 text-right">Actions</th>
                                    </tr>
                              </thead>
                              <tbody class="divide-y divide-slate-100">
                                    <tr *ngFor="let m of list" class="hover:bg-blue-50/50 transition-colors group">
                                          <td class="px-3 py-1.5">
                                                <div class="font-bold text-slate-800 text-[11px]">{{ m.entityName }}
                                                </div>
                                                <div
                                                      class="text-[10px] font-mono text-blue-600 font-bold uppercase truncate">
                                                      {{ m.fieldId
                                                      }}</div>
                                          </td>
                                          <td class="px-3 py-1.5">
                                                <div class="font-medium text-slate-800 text-[11px] leading-tight">{{
                                                      m.label }}</div>
                                                <div class="text-[10px] text-slate-400 font-mono">{{ m.name }}</div>
                                          </td>
                                          <td class="px-3 py-1.5">
                                                <span
                                                      class="px-2 py-0.5 rounded bg-blue-50 border border-blue-100 text-blue-700 text-[9px] uppercase font-bold">
                                                      {{ m.type }}
                                                </span>
                                                <div class="text-[9px] text-slate-400 mt-1 uppercase">{{ m.inputType ||
                                                      'N/A' }} | {{
                                                      m.category }}</div>
                                          </td>
                                          <td class="px-3 py-1.5 text-center">
                                                <span
                                                      [class]="m.isRequired ? 'text-red-500 font-bold text-[10px]' : 'text-slate-300 text-[10px]'">
                                                      {{ m.isRequired ? 'YES' : 'NO' }}
                                                </span>
                                          </td>
                                          <td class="px-3 py-1.5">
                                                <div *ngIf="m.computedExpression"
                                                      class="text-[9px] font-mono text-purple-600 bg-purple-50 px-1.5 py-0.5 rounded truncate">
                                                      ƒ: {{ m.computedExpression }}
                                                </div>
                                                <div *ngIf="m.requiredWhen"
                                                      class="text-[9px] font-mono text-amber-600 bg-amber-50 px-1.5 py-0.5 mt-1 rounded truncate">
                                                      ?: {{ m.requiredWhen }}
                                                </div>
                                          </td>
                                          <td class="px-3 py-1.5">
                                                <div class="text-[10px] text-slate-500 truncate max-w-[180px]"
                                                      [title]="m.dataSource || m.options">
                                                      {{ m.dataSource || m.options || '—' }}
                                                </div>
                                          </td>
                                          <td class="px-3 py-1.5">
                                                <div
                                                      class="text-[10px] text-slate-500 font-medium uppercase leading-none">
                                                      {{ m.visibility
                                                      || 'visible' }}</div>
                                                <div class="text-[9px] font-bold text-slate-400 uppercase mt-1">SEQ: {{
                                                      m.seq }}</div>
                                          </td>
                                          <td class="px-3 py-1.5 text-right">
                                                <div
                                                      class="flex justify-end gap-2 opacity-30 group-hover:opacity-100 transition-opacity">
                                                      <button (click)="openEditModal(m)"
                                                            class="p-1 hover:text-blue-600">
                                                            <svg class="w-4 h-4" fill="none" stroke="currentColor"
                                                                  viewBox="0 0 24 24">
                                                                  <path d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
                                                                        stroke-width="2" />
                                                            </svg>
                                                      </button>
                                                      <button (click)="delete(m.id)" class="p-1 hover:text-red-600">
                                                            <svg class="w-4 h-4" fill="none" stroke="currentColor"
                                                                  viewBox="0 0 24 24">
                                                                  <path d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                                                                        stroke-width="2" />
                                                            </svg>
                                                      </button>
                                                </div>
                                          </td>
                                    </tr>
                              </tbody>
                        </table>
                  </div>
                  <div class="flex items-center justify-between px-4 py-2.5 bg-white border-t border-slate-200">
                        <div class="flex items-center gap-3 font-bold">
                              <span>Show</span>
                              <select [value]="pageSize" (change)="changePageSize($event)"
                                    class="border-2 border-slate-200 rounded px-2 py-1 outline-none focus:border-blue-500 text-xs">
                                    <option [value]="5">5</option>
                                    <option [value]="10">10</option>
                                    <option [value]="25">25</option>
                                    <option [value]="30">30</option>
                                    <option [value]="50">50</option>
                                    <option [value]="80">80</option>
                              </select>
                              <span class="text-slate-500">per page</span>
                        </div>

                        <div class="flex items-center gap-4">
                              <span class="text-slate-600 font-medium">
                                    {{ total === 0 ? 0 : pageIndex * pageSize + 1 }}-{{ (pageIndex + 1) * pageSize >
                                    total ? total : (pageIndex + 1) * pageSize }} of {{ total }}
                              </span>

                              <div class="flex gap-1">
                                    <button (click)="goToPage(pageIndex - 1)" [disabled]="pageIndex === 0"
                                          class="w-8 h-8 flex items-center justify-center rounded border border-slate-300 bg-white hover:bg-slate-100 disabled:opacity-30 shadow-sm">
                                          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path d="M15 19l-7-7 7-7" stroke-width="2" />
                                          </svg>
                                    </button>

                                    <div
                                          class="w-8 h-8 flex items-center justify-center bg-slate-100 border border-slate-200 rounded text-slate-900 font-bold shadow-inner">
                                          {{ pageIndex + 1 }}
                                    </div>

                                    <button (click)="goToPage(pageIndex + 1)"
                                          [disabled]="(pageIndex + 1) * pageSize >= total"
                                          class="w-8 h-8 flex items-center justify-center rounded border border-slate-300 bg-white hover:bg-slate-100 disabled:opacity-30 shadow-sm">
                                          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path d="M9 5l7 7-7 7" stroke-width="2" />
                                          </svg>
                                    </button>
                              </div>
                        </div>
                  </div>
            </div>
      </div>
</div>

<div *ngIf="isModalOpen"
      class="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/40 backdrop-blur-[1px]">
      <div
            class="bg-white rounded shadow-xl w-full max-w-5xl border border-slate-200 overflow-hidden animate-in zoom-in duration-150">
            <div class="flex justify-between items-center border-b border-slate-100 px-5 py-3 bg-slate-50">
                  <h3 class="text-xs font-bold text-slate-800 uppercase tracking-tight">{{ isEditMode ? 'Modify' : 'New'
                        }} Configuration Field</h3>
                  <button (click)="closeModal()"
                        class="text-slate-400 hover:text-slate-600 text-lg font-bold">✕</button>
            </div>

            <div class="p-5 grid grid-cols-4 gap-x-4 gap-y-3 max-h-[75vh] overflow-y-auto">


                  <div class="group">
                        <label class="text-[9px] font-bold text-slate-500 uppercase mb-1 block">
                              Target Entity
                        </label>

                        <select [(ngModel)]="form.entityId" name="entityId"
                              class="w-full border border-slate-200 rounded px-2 py-1.5 text-xs focus:ring-1 focus:ring-blue-500 outline-none">
                              <option [value]="null" disabled>-- Select Entity --</option>
                              <option *ngFor="let ent of entities" [value]="ent.id">
                                    {{ ent.name }} ({{ ent.code }})
                              </option>
                        </select>

                  </div>
                  <!-- <div>
                        <label class="block text-[10px] font-black text-slate-500 uppercase mb-2 tracking-widest">Select
                              Target Entity</label>
                        <select [(ngModel)]="form.entityId"
                              class="w-full px-4 py-2.5 border border-slate-200 rounded text-[11px] font-bold uppercase bg-slate-50 focus:ring-2 focus:ring-blue-500/10 focus:border-blue-500 outline-none transition-all">
                              <option value="" disabled>-- CHOOSE ENTITY --</option>
                              <option *ngFor="let ent of entities" [value]="ent.id">{{ ent.name }} ({{
                                    ent.code }})</option>
                        </select>
                  </div> -->
                  <!-- <div class="group">
                        <label class="text-[9px] font-bold text-slate-500 uppercase mb-1 block tracking-tight">
                              Target Entity
                        </label>
                  
                        <select [(ngModel)]="form.entityId"
                              class="w-full border border-slate-200 rounded px-2 py-1.5 text-xs font-semibold uppercase bg-slate-50 focus:ring-1 focus:ring-blue-500 outline-none transition-all shadow-sm">
                  
                              <option [value]="''" disabled selected>-- CHOOSE ENTITY --</option>
                  
                              <option *ngFor="let ent of entities" [value]="ent.id">
                                    {{ ent.name }} ({{ ent.code }})
                              </option>
                        </select>
                  </div> -->
                  <div>
                        <label class="text-[9px] font-bold text-slate-500 uppercase mb-1 block">Field ID</label>
                        <input [(ngModel)]="form.fieldId"
                              class="w-full border border-slate-200 rounded px-2 py-1.5 text-xs focus:ring-1 focus:ring-blue-500 outline-none font-mono font-bold text-blue-600">
                  </div>
                  <div>
                        <label class="text-[9px] font-bold text-slate-500 uppercase mb-1 block">System Name</label>
                        <input [(ngModel)]="form.name"
                              class="w-full border border-slate-200 rounded px-2 py-1.5 text-xs focus:ring-1 focus:ring-blue-500 outline-none font-mono">
                  </div>
                  <div>
                        <label class="text-[9px] font-bold text-slate-500 uppercase mb-1 block">Display Label</label>
                        <input [(ngModel)]="form.label"
                              class="w-full border border-slate-200 rounded px-2 py-1.5 text-xs focus:ring-1 focus:ring-blue-500 outline-none">
                  </div>

                  <div>
                        <label class="text-[9px] font-bold text-slate-500 uppercase mb-1 block">Control Type</label>
                        <select [(ngModel)]="form.type"
                              class="w-full border border-slate-200 rounded px-2 py-1.5 text-xs focus:ring-1 focus:ring-blue-500 outline-none bg-white">
                              <option value="text">Text Input</option>
                              <option value="select">Select Menu</option>
                              <option value="autocomplete">Autocomplete</option>
                              <option value="datepicker">Date Picker</option>
                        </select>
                  </div>
                  <div>
                        <label class="text-[9px] font-bold text-slate-500 uppercase mb-1 block">Input Type</label>
                        <input [(ngModel)]="form.inputType"
                              class="w-full border border-slate-200 rounded px-2 py-1.5 text-xs focus:ring-1 focus:ring-blue-500 outline-none">
                  </div>
                  <div>
                        <label class="text-[9px] font-bold text-slate-500 uppercase mb-1 block">Category</label>
                        <select [(ngModel)]="form.category"
                              class="w-full border border-slate-200 rounded px-2 py-1.5 text-xs focus:ring-1 focus:ring-blue-500 outline-none bg-white">
                              <option value="static">Static</option>
                              <option value="dynamic">Dynamic</option>
                        </select>
                  </div>
                  <div>
                        <label class="text-[9px] font-bold text-slate-500 uppercase mb-1 block">Sequence</label>
                        <input type="number" [(ngModel)]="form.seq"
                              class="w-full border border-slate-200 rounded px-2 py-1.5 text-xs focus:ring-1 focus:ring-blue-500 outline-none">
                  </div>

                  <div>
                        <label class="text-[9px] font-bold text-slate-500 uppercase mb-1 block">Parent Field</label>
                        <input [(ngModel)]="form.parentField"
                              class="w-full border border-slate-200 rounded px-2 py-1.5 text-xs focus:ring-1 focus:ring-blue-500 outline-none">
                  </div>
                  <div>
                        <label class="text-[9px] font-bold text-slate-500 uppercase mb-1 block">Depends On</label>
                        <input [(ngModel)]="form.dependsOn"
                              class="w-full border border-slate-200 rounded px-2 py-1.5 text-xs focus:ring-1 focus:ring-blue-500 outline-none">
                  </div>
                  <div>
                        <label class="text-[9px] font-bold text-slate-500 uppercase mb-1 block">Visibility</label>
                        <input [(ngModel)]="form.visibility"
                              class="w-full border border-slate-200 rounded px-2 py-1.5 text-xs focus:ring-1 focus:ring-blue-500 outline-none">
                  </div>
                  <div class="flex items-end pb-1.5">
                        <label
                              class="flex items-center gap-2 cursor-pointer bg-slate-50 border border-slate-200 px-2 py-1.5 rounded w-full">
                              <input type="checkbox" [(ngModel)]="form.isRequired"
                                    class="w-3.5 h-3.5 text-blue-600 rounded">
                              <span class="text-[10px] font-bold text-slate-500 uppercase">Required</span>
                        </label>
                  </div>

                  <div class="col-span-2">
                        <label class="text-[9px] font-bold text-slate-500 uppercase mb-1 block">Computed Expression
                              (ƒ)</label>
                        <textarea [(ngModel)]="form.computedExpression" rows="2"
                              class="w-full border border-slate-200 rounded px-2 py-1.5 text-xs font-mono text-purple-600 bg-purple-50/20 outline-none"></textarea>
                  </div>
                  <div class="col-span-2">
                        <label class="text-[9px] font-bold text-slate-500 uppercase mb-1 block">Required When
                              (Condition)</label>
                        <textarea [(ngModel)]="form.requiredWhen" rows="2"
                              class="w-full border border-slate-200 rounded px-2 py-1.5 text-xs font-mono text-amber-600 bg-amber-50/20 outline-none"></textarea>
                  </div>

                  <div class="col-span-2">
                        <label class="text-[9px] font-bold text-slate-500 uppercase mb-1 block">Data Source URL</label>
                        <input [(ngModel)]="form.dataSource"
                              class="w-full border border-slate-200 rounded px-2 py-1.5 text-xs font-mono outline-none">
                  </div>
                  <div class="col-span-2">
                        <label class="text-[9px] font-bold text-slate-500 uppercase mb-1 block">Display Source
                              Path</label>
                        <input [(ngModel)]="form.displaySource"
                              class="w-full border border-slate-200 rounded px-2 py-1.5 text-xs font-mono outline-none">
                  </div>

                  <div class="col-span-2">
                        <label class="text-[9px] font-bold text-slate-500 uppercase mb-1 block">Static Options
                              (JSON)</label>
                        <textarea [(ngModel)]="form.options" rows="2"
                              class="w-full border border-slate-200 rounded px-2 py-1.5 text-xs font-mono outline-none"></textarea>
                  </div>
                  <div class="col-span-2">
                        <label class="text-[9px] font-bold text-slate-500 uppercase mb-1 block">Field Events
                              (JSON)</label>
                        <textarea [(ngModel)]="form.events" rows="2"
                              class="w-full border border-slate-200 rounded px-2 py-1.5 text-xs font-mono outline-none"></textarea>
                  </div>

                  <div>
                        <label class="text-[9px] font-bold text-slate-500 uppercase mb-1 block">Placeholder</label>
                        <input [(ngModel)]="form.placeholder"
                              class="w-full border border-slate-200 rounded px-2 py-1.5 text-xs outline-none">
                  </div>
                  <div>
                        <label class="text-[9px] font-bold text-slate-500 uppercase mb-1 block">Reference</label>
                        <input [(ngModel)]="form.reference"
                              class="w-full border border-slate-200 rounded px-2 py-1.5 text-xs outline-none">
                  </div>
                  <div>
                        <label class="text-[9px] font-bold text-slate-500 uppercase mb-1 block">Soft Max</label>
                        <input type="number" [(ngModel)]="form.softMax"
                              class="w-full border border-slate-200 rounded px-2 py-1.5 text-xs outline-none">
                  </div>
                  <div>
                        <label class="text-[9px] font-bold text-slate-500 uppercase mb-1 block">State</label>
                        <input [(ngModel)]="form.state"
                              class="w-full border border-slate-200 rounded px-2 py-1.5 text-xs outline-none">
                  </div>
            </div>

            <div class="flex justify-end gap-2 p-4 border-t border-slate-100 bg-slate-50">
                  <button (click)="closeModal()"
                        class="px-4 py-1.5 border border-slate-200 text-slate-600 rounded font-bold hover:bg-white text-[10px] uppercase transition-all">Cancel</button>
                  <button (click)="save()"
                        class="px-6 py-1.5 bg-blue-600 text-white rounded font-bold hover:bg-blue-700 shadow-sm text-[10px] uppercase transition-all">
                        {{ isEditMode ? 'Update Configuration' : 'Save New Field' }}
                  </button>
            </div>
      </div>
</div>